<div class="row h-100 noMarginLeftRight">
    <div class="col-12">
        <div class="headerAddDevices">
            <button class="sausageSelectBtn" (click)="showAutocomplete()">
                <div>
                    <p>{{ 'TAB_STEPPER.SELECT_FACTORY' | translate }}</p>
                    <mat-select #autocomplete (ngModelChange)="selectFactoryEvent($event)" [formControl]="factoria"
                        multiple>
                        <mat-option *ngFor="let factory of factoryCollection?.collection" [value]="factory">
                            {{factory.descripcion}}</mat-option>
                    </mat-select>
                </div>
            </button>
            <button mat-raised-button class="primaryBtn text-right sizeButton"
                [disabled]="selectedDeviceList.length < 1"
                (click)="addDevices()">{{ 'DISPOSITIVOS.ADD_DEVICES' | translate}}</button>
        </div>

        <mat-form-field class="fullWidth">
            <div>
                <p *ngIf="selectedDeviceList.length > 0" class="text-left">{{  'TAB_STEPPER.DEVICES_SELECTED' | translate}}</p>
                <p title="Este campo es requerido" *ngIf="selectedDeviceList.length < 1" class="text-left">
                    {{ 'TAB_STEPPER.NO_DEVICES_SELECTED' | translate}}<span title="Este campo es requerido"
                        class="required">*</span>
                </p>
                <mat-chip-list #chipList>
                    <mat-chip class="unselectable btnForm" *ngFor="let device of selectedDeviceList"
                        (removed)="removeChipset(device)">
                        {{device.name}}
                        <mat-icon class="chipsetCancel" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>
        </mat-form-field>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div *ngIf="factoriesSelected.collection.length < 1">
                        <div class="container mtop5">
                            <div class="text-center">
                                <app-svg name="no-factory"></app-svg>
                            </div>
                            <div class="text-center warning-factories">
                                <h3>{{ 'WARNING_MESSAGES.NO_FACTORIES_SELECTED' | translate}}</h3>
                                <p class="dib">{{ 'WARNING_MESSAGES.CHOOSE_ICON_ADD_FACTORY' | translate}} &nbsp;</p>
                            </div>
                        </div>
                    </div>
                    <mat-tab-group animationDuration="0" *ngIf="factoriesSelected.collection.length > 0"
                        [selectedIndex]="selectedFactory.value"
                        (selectedIndexChange)="selectedFactory.setValue($event)">

                        <div *ngFor="let factory of factoriesSelected.collection; let i = index">
                            <mat-tab [label]="factory.descripcion">
                                <div class="container mtop5">
                                    <div class="row">
                                        <div class="col-md-12 mBottom5">
                                            <app-graphis-devices-hierarchi [title]="title[i]"
                                                [deviceChildrenList]="childrens[i]"
                                                (deviceItemSelected)="selectedDeviceGraphItem($event)"
                                                (deviceItemUnSelected)="unSelectedDeviceGraphItem($event)"
                                                (deviceItemNavegate)="navigate($event,i)" (goBackOnDevices)="goBack(i)"
                                                [loadingChildren]="loading[i]" [isRoot]="isRoot[i]">
                                            </app-graphis-devices-hierarchi>
                                        </div>

                                    </div>
                                </div>
                            </mat-tab>
                        </div>

                    </mat-tab-group>
                </div>

            </div>

        </div>
    </div>
</div>